import { useMemo } from "react";
import classnames from "classnames";
import CardArtwork from "@/components/Card/CardArtwork";
import { ButtonLink } from "@/components/Buttons/index";
import styles from "@/styles/Row.module.scss";
import VersatileLink from "@/components/VersatileLink";

export default function AdvertjPickupListRow({ item }) {
  const target = useMemo(() => {
    if (item.targetBlank) {
      return "_blank";
    } else {
      return "_self";
    }
  }, [item]);

  return (
    <div className={classnames(styles.container, styles.pickup)}>
      <div className={styles.inner}>
        <div className={styles.artwork}>
          <CardArtwork
            item={item}
            className={styles.artworkInner}
            href={item.url}
            linkAttr={{ target, rel: "noopener noreferrer" }}
          />
        </div>
        <div className={styles.info}>
          <h4 className={styles.title}>
            <VersatileLink
              target={target}
              rel="noopener noreferrer"
              href={item.url}
            >
              {item.name}
            </VersatileLink>
          </h4>
          <p className={styles.description}>{item.description}</p>
          <div className={styles.buttons}>
            <ButtonLink
              fillColor
              medium
              href={item.url}
              atagProps={{ target, rel: "noreferrer noopener" }}
            >
              詳細を見る
            </ButtonLink>
          </div>
        </div>
      </div>
    </div>
  );
}
